import { splitSearchIndex } from '@client-shared/utils/search-helpers.js'

// Caches the search index of every item as its lowercased segments, so a keystroke in a search
// input only matches against them instead of rebuilding, lowercasing and splitting the index of
// every item. Items are replaced, never changed in place, so the item itself is the key. The
// dependencies are the other inputs of the index (the project and its participants, for example):
// a changed one rebuilds it on the next search
export default function createSearchIndexCache () {
  const searchIndexes = new WeakMap()

  return ({ item, dependencies, generateText }) => {
    const searchIndex = searchIndexes.get(item)

    if (searchIndex && searchIndex.dependencies.every((dependency, index) => dependency === dependencies[index])) {
      return searchIndex.textSegments
    }

    const textSegments = splitSearchIndex(generateText())

    searchIndexes.set(item, {
      dependencies,
      textSegments,
    })

    return textSegments
  }
}
